import request from '@/utils/request'

//  新增优惠券
export const addCoupon = (formData) => {
    return request.post('/coupon', formData)
}

//  修改优惠券
export const editCoupon = (updateData) => {
    return request.put('/coupon', updateData)
}

// 优惠券记录列表
export const listCouponUser = (pageData, formData) => {
    return request.post(`/coupon/user/${pageData.page}/${pageData.pageSize}`, formData)
}

// 新增优惠券记录
export const addUserCoupon = (formData) => {
    return request.post('/coupon/user', formData)
}

// 优惠券记录详情
export const detailCouponUser = (id) => {
    return request.get(`/coupon/user/${id}`)
}

// 修改优惠券记录
export const editCouponUser = (updateData) => {
    return request.put('/coupon/user', updateData)
}